$(document).ready(function () {

    $("a#ShareViaMail").live("click", function myfunction() {

        $("#ShareWithEmailModal").modal("show");

        var imagePath = $(".SmallProductImages img.Selected").first().attr("src");
        var desc = $("#PrdInfo").text();

        $(".ShareDetails").html("");

        $(".ShareDetails").append($(".ProductHeader:first").clone());
        $(".ShareDetails").append("<br />");
        $(".ShareDetails").append($(".PrdouctCode:first").clone());

        $(".ShareDetails").append("<img style='float:left;' src=" + imagePath + " alt='' />");

        $(".ShareDetails").append("<p>" + desc + "</p>");

        $(".ShareDetails").append('<input name="ProductID" type="hidden" value="' + $("#ProductID").val() + '" />');
        $(".ShareDetails").append('<input name="ProductCode" type="hidden" value="' + $(".PrdouctCode:first").text() + '" />');
        $(".ShareDetails").append('<input name="ProductName" type="hidden" value="' + $(".ProductHeader:first").text() + '" />');
        $(".ShareDetails").append('<input name="Description" type="hidden" value="' + desc + '" />');

        $(".ShareDetails").append('<input name="Url" type="hidden" value="' + document.location.href + '" />');
        $(".ShareDetails").append('<input name="ColorID" type="hidden" value="' + $("#ColorID").val() + '" />');
        $(".ShareDetails").append('<input name="ImagePath" type="hidden" value="' + imagePath + '" />');


    });

    $("form.ShareWithMailForm").live("submit", function () {

        $(".AjaxLoader").show();

        $.ajax({
            type: $(this).attr("method"),
            url: $(this).attr("action"),
            data: $(this).serialize(),
            cache: false,
            success: function (data) {

                if (data.Sonuc == true) {
                    $(".ShareDetails").html("");
                    $(".ShareWithMailForm input, .ShareWithMailForm textarea, .ShareWithMailForm button , .ShareWithMailForm p").hide();
                    $(".ShareWithMailForm input, .ShareWithMailForm textarea, .ShareWithMailForm button").html("");

                    $("#SuccesResult").html(data.IslemSonucAciklama);
                    $("#SuccesResult").show();
                    $("#ErrorResult").hide();
                }
                else {
                    $("#ErrorResult").html(data.IslemSonucAciklama);
                    $("#ErrorResult").show();
                    $("#SuccesResult").hide();
                }


                $(".AjaxLoader").hide();
            }
        });

        return false;

    });



    $("#NotifyModal #RemindMeLater.active").live("click", function myfunction() {

        var StockIDs = "?x=";
        var curVal = 0;

        $(".NotiyfyRow .OutOfStockRemind.active").each(function (index) {

            StockIDs += "&[" + curVal + "].StockID=" + $(this).attr("data-StockID");
            StockIDs += "&[" + curVal + "].SizeID=" + $(this).attr("data-sizeID");
            StockIDs += "&[" + curVal + "].ProductID=" + $(this).attr("data-ProductID");
            StockIDs += "&[" + curVal + "].ProductCode=" + $(this).attr("data-ProductCode");
            StockIDs += "&[" + curVal + "].ColorID=" + $(this).attr("data-colorid");

            curVal++;

        });
        var name = $('input[name="NameModal"]').val();
        var username = $('input[name="UserNameModal"]').val();

        var gsm = $('input[name="GsmModal"]').val();
        var gsmLen = 0;

        if (gsm != "" && gsm != null) {
            gsmLen = gsm.length;
        }

        var kvkk = $('input[name="KVKKModal"]').prop("checked");
        var allowConsent = $('input[name="AROmodal"]').prop("checked");
        $(".AjaxLoader").show();
        if (name != null && username != null && name != "" && username != "" && gsm != null && gsm != "") {
            if (gsmLen < 10) {
                $("#AlertResultRemind").show();
                $("#AlertResultRemind span").html("Lütfen gerçerli bir GSM numarası giriniz.");
            }
            else {
                $.ajax({
                    type: "POST",
                    url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/RemindMeWhenAvailable",
                    data: StockIDs + "&Name=" + name + "&UserName=" + username + "&Gsm=" + gsm + "&Kvkk=" + kvkk + "&AllowConsent=" + allowConsent,
                    dataType: "json",
                    success: function (dt) {

                        $(".AjaxLoader").hide();
                        $("#AlertResultRemind").show();

                        $("#AlertResultRemind span").html(dt.IslemSonucAciklama);

                        if (dt.Sonuc == true) {

                            $("#AlertResultRemind").removeClass("alert-error");
                            $(".NotiyfyRow").hide();
                            $("#NotifyModal .modal-footer").addClass("hide");
                            $("#NotifyModal .NotifyWarning").html("<img src='/images/JMK/Icons/check.png' style='width:40px;' /> <h3 style='margin-bottom:0px;'>Talebini Aldık.</h3>");

                        }
                        else {

                            $("#AlertResultRemind").removeClass("alert-success");
                            $("#AlertResultRemind").addClass("alert-error");


                        }

                    },
                    error: function () {

                        $(".AjaxLoader").hide();
                        alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                    }

                });
            }
        } else {
            $("#AlertResultRemind").show();
            $("#AlertResultRemind span").html("Lütfen Tüm Alanları Doldurunuz.");
        }



        return false;

    });

    $("#PrdBlackBg").live("click", function myfunction() {

        $(".SizeOptions, .CombineSizeOptions").removeClass("PleaseSelect");
        $(this).hide();

    });

    $(".NotifyColors a.OutOfStockRemind").live("click", function myfunction() {

        $(this).toggleClass("active");

        if ($(".NotiyfyRow .OutOfStockRemind.active").length <= 0) {
            $("#NotifyModal #RemindMeLater").removeClass("active");
        }
        else {
            $("#NotifyModal #RemindMeLater").addClass("active");
        }

    });

    $("#NotifyModal").on('shown.bs.modal', function () {
    });


    $('.ReminderSizeOptions a').live("click", function () {

        $("input#ReminderSizeID").val($(this).attr("data-id"));

        $(this).parent().find("a").removeClass("active");
        $(this).addClass("active");


    });

    $('#RemindList').live('click', function () {

        if ($('#UserName').length > 0) {
            window.location.href = "http://" + $('#UserName').val();
        }
        else {
            $('#RemindModal').modal("show");
        }

    });

    $('#RemindModal .modal-footer a:first').live('click', function () {

        $('#RemindModal').modal("hide");
    });

    $('.remind-success a').live('click', function () {

        $('#RemindModal').modal("hide");
    });

    $('#RemindAvailable').live('click', function () {

        var params = "ColorID=" + $('.Colors a.active').attr("data-id") + "&PID=" + $('#PID').val() + "&SizeID=" + $("input#ReminderSizeID").val() + "&ProductCode=" + $('.PrdouctCode').html() + "&UserPhone=" + $('#UserPhone').val();

        $.ajax({
            type: "GET",
            url: "/Orders/RemindMeWhenAvailable",
            data: params,
            success: function (data) {
                if (data.Sonuc == true) {
                    $('#RemindModal .modal-body .remind-success').show();
                    $('#RemindModal .modal-body .alert-error').hide();
                    $('.RemindInfo').hide();
                    $('.RemindSonucTrue').html(data.IslemSonucAciklama);
                }
                else {
                    $('#RemindModal .modal-body .alert-error').show();
                    $('#RemindModal .modal-body .remind-success').hide();
                    $('.RemindInfo').show();
                    $('.RemindSonucTrue').hide();
                    $('.RemindSonucFalse').html(data.IslemSonucAciklama);
                }

            },
            error: function () {
                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });
    });


    if ($(".NewPD").length > 0) {

        var colorID = $("#ColorID").val();

        if (colorID != undefined && colorID.length > 0) {

            $(".SizeOptions, .SizeAndAmount span.ChooseTitle ").addClass("open");

            $(".Colors span.ChooseTitle").removeClass("current");
            $(".Colors span.ChooseTitle").addClass("passed");

            $(".SizeAndAmount span.ChooseTitle").addClass("current");
            $(".SizeAndAmount span.ChooseTitle").removeClass("passed");

            $(".AmountOptions span.ChooseTitle").removeClass("current");
            $(".AmountOptions span.ChooseTitle").removeClass("passed");

        }

        if ($(".AutoTextRep").length > 0) {

            $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
            $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());
        }

        $(".Sizes").find(".Name").html("");

    }

});